import typeScale from "../../../images/v2/brand-asset/typeScale.png";

const TypeScale = () => {
  const typeScaleItem = [
    "Our type scale reflects the overall typography system. Sizing is specified to ensure consistency across both print and digital applications, as each may require certain specific sizes for clarity and readability.",
  ];
  return (
    <section
      id="type-scale"
      className="w-full flex flex-col xl:relative xl:min-h-[580px] justify-between gap-6  bg-white"
    >
      <figure className="w-full h-[250px] xl:h-[550px] overflow-hidden">
        <img
          src={typeScale}
          className="w-full h-full object-contain"
          alt="Avatar Mark"
        />
      </figure>
      <ul className="w-[90%] max-w-[730px] xl:absolute xl:bottom-6 xl:left-1/2 xl:-translate-x-1/2 mx-auto mb-5 xl:mb-0 sm:flex-row flex-col flex gap-5 justify-between">
        {typeScaleItem.map((item, index) => (
          <li className="text-[#AB8599] xl:w-1/2 text-sm" key={index}>
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default TypeScale;
